/* eslint-disable import/prefer-default-export */
import isbot from 'isbot';

export const notAHuman = () => {
  isbot.extend(['chrome-lighthouse', 'gtmetrix']);
  return isbot(navigator.userAgent);
};
